import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    invitationConfirmation: 'The invitation has been sent to {firstName}',
    roleAppliedConfirmation: 'The new role has been applied to {firstName}',
    sendInvitation: 'Send invitation',
    submit: 'Continue',
    title: 'Define their role',
    titleAccountantOnly: 'Invite your accountant to join your Shine account',
  },
  fr: {
    invitationConfirmation: 'L’invitation a bien été envoyée à {firstName}',
    roleAppliedConfirmation: 'Le nouveau rôle a été appliqué à {firstName}',
    sendInvitation: 'Envoyer l’invitation',
    submit: 'Continuer',
    title: 'Définissez son rôle',
    titleAccountantOnly:
      'Inviter votre comptable à rejoindre votre compte Shine',
  },
} as const);

export default locales;
